/*       */

import { gql } from '@apollo/client';
import { typeMap } from 'app/config/typesConfig';

const _fields = `
    id
    type
    name
    primary
`;

export default gql`
    query dashboardEntitiesQuery($orderBy: [JSON], $filterBy: [JSON]) {
        records: entities(type: "${typeMap.dashboard}", orderBy: $orderBy, filterBy: $filterBy) {
            ${_fields}
        }
    }
`;

export const UPDATE_DASHBOARD_MUTATION = gql`
    mutation updateDashboardEntity($record: EntityUpdateInput!) {
        result: updateEntity(record: $record) {
            id
        }
    }
`;

export const DASHBOARD_MAP_QUERY = gql`
    query mapEntity($id: ID!) {
        entity(type: "system_map", id: $id) {
            id
            name
            primary
        }
    }
`;
